import { Avatar, Text, mergeClasses } from "@fluentui/react-components";
import type { UserProfile } from "../services/graphService";
import { useUiStyles, SparkleIcon } from "./ui";
import { useLanguage } from "../i18n/LanguageContext";

export function WelcomeHeader({ profile }: { profile: UserProfile | null }) {
  const s = useUiStyles();
  const { t } = useLanguage();
  const name = profile?.displayName ?? "there";
  const firstName = name.split(" ")[0];
  const subtitle = profile?.jobTitle
    ? `${profile.jobTitle}${profile.mail ? ` · ${profile.mail}` : ""}`
    : profile?.mail ?? t("welcome.defaultSubtitle");

  return (
    <header className={mergeClasses(s.hero, s.heroAccent)}>
      <Avatar name={name} color="colorful" size={48} aria-hidden />
      <div className={s.grow}>
        <Text size={500} weight="semibold" block>
          {t("welcome.greeting", { name: firstName })}
        </Text>
        <Text size={200} block style={{ color: "var(--colorNeutralForeground3)" }} truncate wrap={false}>
          {subtitle}
        </Text>
      </div>
      <span className={s.chip}>
        <SparkleIcon />
        Lite
      </span>
    </header>
  );
}
